
import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import { Group, ListItem } from '../backend/backendapi';
import $ from 'jquery';
import GroupEditor from './EditModal/GroupEditor';
import Spinner from '../util/Spinner';
import {TabId} from "./EditModal/GroupEditor.vue";
import { GroupSelector } from './util';

@Component({
  components: {
    GroupEditor,
    Spinner,
    SelectModal: require('../selectmodal/selectmodal.vue.html').default,
  },
})
export default class EditModal<T> extends Vue {
  @Prop({ required: true })
  readonly allUsers!: ListItem[];
  @Prop({ required: true })
  readonly availableSalutations!: string[];
  @Prop({ default: '' })
  readonly groupSelector!: GroupSelector<T>;
  @Prop({ default: () => (g: Group) => Group.fromJS(g) })
  readonly groupCopyFunction!: ((t: T) => T);
  @Prop({ default: null })
  readonly groupSaveFunction!: ((t: T) => Promise<T>) | null;
  @Prop({ default: () => [] })
  readonly hiddenTabs!: TabId[];
  @Prop({ default: () => new Map() })
  readonly tabTitles!: Map<TabId, string>;
  @Prop({ default: false })
  readonly hidePinned!: boolean;
  @Prop({ default: false })
  readonly hideExternalUserDisabled!: boolean;
  @Prop({ default: false })
  readonly hideMassSelection!: boolean;
  @Prop({ default: false })
  readonly allowNoEmailForExternalUsers!: boolean;

  saving = false;
  group: T | null = null;

  public open(group: T): void {
    this.group = this.groupCopyFunction(group);
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }

  //events
  async onSave(): Promise<void> {
    if (!this.group) {
      return;
    }

    this.saving = true;
    try {
      const res = await (this.$refs.groupEditor as GroupEditor<T>).onSave();
      if (res) {
        this.group = res;
      }
    } finally {
      this.saving = false;
    }
  }
}
